// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ** Third Party
import cookie from "js-cookie";

// ** Configuration
import configGlobal from "configuration";

// ############################################################

export const login = createAsyncThunk(
	"auth/login",
	createApiCall(async ({ username, password, fingerprint }, client) => {
		const response = await client.post(
			`/authorization/login/web`,
			{
				login: username,
				password,
				fingerprint: fingerprint || "",
			},
			{
				headers: {
					Accept: "application/api.1.1+json",
				},
			},
		);

		const token = response?.headers?.authorization
			? response.headers.authorization.match(/Bearer\s(\S+)/)[1]
			: null;

		if (token) {
			client.addAuthToken(token);
			cookie.set(configGlobal.auth.cookieName, token, {
				...configGlobal.auth.cookieOptionsJsCookie,
			});
		}

		return { result: response.data, isTokenExists: !!token };
	}),
);

// ############################################################
